const HELP_WINDOW_NAME = 'summit_help'
const HELP_WINDOW_FEATURES = 'popup=yes,width=960,height=720,top=80,left=80,resizable,scrollbars'

export default function openHelp (section) {
  window.open(
    `${window.location.origin}/help/${section}`,
    HELP_WINDOW_NAME,
    HELP_WINDOW_FEATURES
  )
}
